import api from '@/services/api'
import axios from 'axios'

export default {
  fetchWidgets() {
    return api().post('widgets/get',  {domain: localStorage.domain, apikey: localStorage.apikey});
  },
  updateWidgetStatus(status, widgetId) {
    return api().post('widgets/link', {domain: localStorage.domain, apikey: localStorage.apikey, status: status, widget: widgetId});
  },
  updateWidgetSettings(widgetId, settings){
    return api().post('widgets/set_settings', {domain: localStorage.domain, apikey: localStorage.apikey, widget: widgetId, settings: settings });
  },
  getWidget(widgetId){
    return api().post('widgets/get_widget', {domain: localStorage.domain, apikey: localStorage.apikey, widget: widgetId});
  },
  // Для личного кабинета
  getWidgetsList(){
    return api().post('widgets/get_widgets_list', {domain: localStorage.domain, apikey: localStorage.apikey });
  },

  // amocrm
  getCompanyFields(){
    return api().post('amocrm/get_company_fields', {domain: localStorage.domain, apikey: localStorage.apikey});
  },
  createCompanyField(fieldName){
    return api().post('amocrm/create_company_field', {domain: localStorage.domain, apikey: localStorage.apikey, name: fieldName});
  },
  getLeadFields(types){
    return api().post('amocrm/get_lead_fields', {domain: localStorage.domain, apikey: localStorage.apikey, types: types});
  },
  getPipelines() {
    return api().post('amocrm/get_pipelines', {domain: localStorage.domain, apikey: localStorage.apikey});
  },
  getStatuses(pipeline) {
    return api().post('amocrm/get_statuses', {domain: localStorage.domain, apikey: localStorage.apikey, pipeline: pipeline});
  },

  // dadata
  getInnData(query) {
    return api().post('dadata/get_inn_data', {domain: localStorage.domain, apikey: localStorage.apikey, inn: query});
  },

  // user
  updateRequisites(requisites){
    return api().post('users/update_requisites', {domain: localStorage.domain, apikey: localStorage.apikey, requisites: requisites});
  },
  getRequisites(){
    return api().post('users/get_requisites', { domain: localStorage.domain, apikey: localStorage.apikey });
  },
  getUserInfo() {
    return api().post('users/get_user_info', { domain: localStorage.domain, apikey: localStorage.apikey });
  },
  updateUserBalance(amount) {
    return api().post('users/deposite', { domain: localStorage.domain, apikey: localStorage.apikey, amount: amount });
  },
  getPaymentsLog() {
    return api().post('users/get_payments_log', { domain: localStorage.domain, apikey: localStorage.apikey });
  },
  generateBillPdf(balance) {
    return api().post('users/generate_bill_pdf', { domain: localStorage.domain, apikey: localStorage.apikey, balance: balance });
  },
  getDocs() {
    return api().post('users/get_docs', { domain: localStorage.domain, apikey: localStorage.apikey });
  },

  // Скачивание файла
  getBillPdf(id, callback){
    axios({ 
      url: 'https://amo.konovalov.biz/api/users/get_doc_pdf',
      method: 'POST',
      data :  { domain: localStorage.domain, apikey: localStorage.apikey, doc: id },
      responseType: 'blob',
    }).then((response) => { callback(response); });
  }
}